<div class="header">
  <div class="title">New Compset</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addCompsetForm">
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>What do you want to call this compset?</mat-label>
    <input matInput [formControlName]="'title'" />
  </mat-form-field>

  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Select Compset Type</mat-label>
    <mat-select [formControlName]="'compset_type'">
      <mat-option value="static">Static</mat-option>
      <mat-option value="dynamic">Dynamic</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="actions justify-between">
    <a
      class="flex gap-2 text-gray-400 text-sm"
      href="https://help.termsheet.com/add-compsets-to-deal-insights"
      target="_blank"
    >
      <ts-icon icon="help_outline"></ts-icon> Learn about Compsets
    </a>

    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="isSaveBtnDisabled"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="save()"
      >
        <span *ngIf="!isLoading">Save</span>
        <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
